import { styled } from '@linaria/react';

import { MqTablet } from '~theme/media';

export const BannerSlidesContainer = styled.div`
	position: absolute;
	right: 20px;
	bottom: 20px;
	display: flex;
	width: fit-content;
	flex-direction: row;
	gap: 30px;
`;

export const PageIndicatorContainer = styled.div`
	display: none;
	flex-direction: row;
	align-items: center;
	gap: 5px;

	${MqTablet} {
		display: flex;
	}
`;

export const ButtonsContainer = styled.div`
	display: flex;
	height: 38px;
	gap: 10px;
`;

export const SliderButton = styled.button`
	display: flex;
	width: 38px;
	height: 38px;
	align-items: center;
	justify-content: center;
	border-radius: var(--radius-m);
	background-color: var(--color-white-xs);
`;

export const CloseButton = styled.button`
	position: absolute;
	z-index: 1;
	top: 12px;
	right: 12px;
	width: 24px;
	height: 24px;
	padding: 4px;
	border-radius: 100%;

	& path {
		fill: var(--color-white-solid);
	}
`;
